import React, { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { CommunicationMethodSelector } from '@/components/composed/financing/CommunicationMethodSelector'
import type { TFinancingRequestStepperAfterFormSubmitComponentProps } from '@/components/composed/financing/FinancingRequestStepper/types'
import { openModal } from '@/components/composed/Modal/actions'
import { addModalToWellKnown } from '@/components/composed/Modal/constants'
import { FinancingUxFeedbackModal } from '@/components/composed/modals'
import type { IFinancingUxFeedbackModalProps } from '@/components/composed/modals/FinancingUxFeedbackModal/types'
import { FinancingConsultingWrapper } from '../FinancingConsultingWrapper'
import './styles.scss'

addModalToWellKnown({ FinancingUxFeedbackModal })

export const FinancingConsultingCommunicationMethodSelector = ({
  state: { fundingRequestId },
  onSuccess,
  onError,
}: TFinancingRequestStepperAfterFormSubmitComponentProps<{}>) => {
  const dispatch = useDispatch()

  const handleSuccessUpdateFundingRequest = useCallback(() => {
    onSuccess(fundingRequestId)

    dispatch(
      openModal({
        options: { dialogId: 'FinancingUxFeedbackModal', shouldBlockedScroll: false },
        contentOptions: { isHasSkipButton: false } as IFinancingUxFeedbackModalProps['options'],
      }),
    )
  }, [dispatch, fundingRequestId, onSuccess])

  return (
    <FinancingConsultingWrapper isFollowingStep>
      <CommunicationMethodSelector
        className="financingConsultingCommunicationMethod"
        titleClassName="financingConsultingCommunicationMethod__title"
        containerClassName="financingConsultingCommunicationMethod__container"
        buttonClassName="financingConsultingCommunicationMethod__button"
        fundingRequestId={fundingRequestId}
        onSuccessUpdateFundingRequest={handleSuccessUpdateFundingRequest}
        onErrorUpdateFundingRequest={onError}
      />
    </FinancingConsultingWrapper>
  )
}
